import * as types from './constants';

// Create Promotion
export const createPromotionRequest = data => (
  { type: types.CREATE_PROMOTION_REQUEST, payload: data }
);

export const createPromotionDone = data => (
  { type: types.CREATE_PROMOTION_DONE, payload: data }
);

export const createPromotionFailed = errors => (
  { type: types.CREATE_PROMOTION_FAILED, payload: errors }
);

export const createPromotionReset = () => (
  { type: types.CREATE_PROMOTION_RESET }
);